import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-10afd96a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Op het Lint logo",
  src: _imports_0,
  style: {"max-width":"300px"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Orthopedagogiek is een specialisme binnen de pedagogische wetenschap dat zich richt op het onderzoeken en behandelen van kinderen en jongeren met een bepaalde beperking en/of problematische opvoedsituatie."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", null, "Op het Lint Orthopedagogiek"),
    /*#__PURE__*/_createTextVNode(" wil graag laagdrempelige ondersteuning bieden aan kinderen en hun ouders wanneer zij vragen of hulp nodig hebben op het gebied van:")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Opvoeding"),
    /*#__PURE__*/_createElementVNode("li", null, "Leren"),
    /*#__PURE__*/_createElementVNode("li", null, "Gedrag"),
    /*#__PURE__*/_createElementVNode("li", null, "Sociaal emotioneel welbevinden"),
    /*#__PURE__*/_createElementVNode("li", null, "Aandacht en concentratie"),
    /*#__PURE__*/_createElementVNode("li", null, "Dagelijks functioneren")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "De hulp bestaat uit het doen van diagnostiek en behandelen."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Op het Lint Orthopedagogiek is vernoemd naar het pad rondom het "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.google.com/maps/place/Maximapark/@52.0964476,5.0242428,14z/data=!4m8!1m2!3m1!2sMaximapark!3m4!1s0x47c6701dddafc5dd:0x471b6ef66947ab31!8m2!3d52.0987288!4d5.0249362",
      target: "_blank"
    }, "Máximapark"),
    /*#__PURE__*/_createTextVNode(" tussen Vleuten en Leidsche Rijn. Dit is het werkgebied van zelfstandig orthopedagoog "),
    /*#__PURE__*/_createElementVNode("b", null, "Marianne Joosen"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayLottieFile = _resolveComponent("PlayLottieFile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_PlayLottieFile, { file: "@/assets/kikker.json" })
  ], 64))
}